import * as reportActions from 'action/report'
import * as totalAccuracyActions from 'action/totalAccuracy'
import * as spinnerActions from 'action/spinner'
import CommonReport from 'component/commonReport/CommonReport'
import PropTypes from 'prop-types'
import React from 'react'
import applyMask from 'component/report/utils/Formatter'
import { bindActionCreators } from 'redux'
import columns from 'component/totalAccuracy/columns'
import { connect } from 'react-redux'
import { renderToastWarn } from 'utils/ToastUtils'
import { translate } from 'react-i18next'

let signalController;
class TotalAccuracy extends React.Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    fetchTotalAccuracy: PropTypes.func,
    fetchTotalAccuracyReactive: PropTypes.func,
    fetchFluxReport: PropTypes.func,
    error: PropTypes.object,
    count: PropTypes.number.isRequired,
    record: PropTypes.array.isRequired,
    fetchReports: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
    canceled: PropTypes.bool,
    hideSpinner: PropTypes.func,
  }

  state = {
    formData: {},
    subtypesQuery: false,
  }

  getFormFields() {
    const { translate } = this.props
    const dtCurrentYear = new Date().getFullYear()
    const fields = [
      {
        type: 'branchs',
        name: 'idBranches',
        label: translate('field.store'),
        help_text: translate('totalAccuracy.store'),
        required: true,
      },
      {
        type: 'LM',
        name: 'cdLm',
        help_text: translate('mobile.hint.lm'),
        label: translate('query.logs.listId'),
        attrs: {
          maxLength: 8,
          mask: '99999999',
        },
        required: false,
      },
      {
        type: 'input',
        name: 'dtYear',
        label: translate('totalAccuracy.dtYear'),
        help_text: translate('totalAccuracy.dtYear.placeholder'),
        required: true,
        attrs: {
          maxLength: 4,
          mask: '9999',
          helpText: `${translate(
            'totalAccuracy.dtYear.error'
          )} ${dtCurrentYear}`,
          errorText: `${translate(
            'totalAccuracy.dtYear.error'
          )} ${dtCurrentYear}`,
          validateValue: (value) => {
            if (value >= '2019' && value <= dtCurrentYear) return true
            return false
          },
        },
      },
    ]
    return fields
  }

  getColumns() {
    const { translate } = this.props

    const cols = {}

    for (const col of columns) {
      if (col.render) {
        cols[col.field] = {
          fixed: col.fixed,
          label: translate(col.headerLabel),
          align: col.align,
          customWidth: col.customWidth || false,
          disableOrder: col.field !== 'dtInclusion',
        }
      }
    }

    return cols
  }

  buildRows() {
    const { record, translate } = this.props

    const rows = []
    let i = 0

    for (const rec of (record.listPresenter || [])) {
      if (rec.dsBranch !== 'Subtotal') {
        rows[i] = {}
        for (const col of columns) {
          if (col.render) {
            if (rec[col.field] || rec[col.field] === 0) {
              rows[i][col.field] =
                rec.dsBranch === 'Total LMB'
                  ? `<b>${applyMask(
                    col.type,
                    rec[col.field],
                    translate,
                    col.headerLabel
                  )}</b>`
                  : applyMask(
                    col.type,
                    rec[col.field],
                    translate,
                    col.headerLabel
                  )
            } else {
              rows[i][col.field] = '-'
            }
          }
        }
        i++
      }
    }

    return rows
  }

  componentWillUnmount() {
    if(signalController) {
      signalController.abort()
    }
  }


  onSubmitFlux = async (data, callback) => {
    const {
      auth: {
        user: { dsToken },
      },
      hideSpinner,
      fetchTotalAccuracyReactive,
    } = this.props

    delete data.period
    data.size = 10
    data.hasPagination = true

    signalController = new AbortController();
    await fetchTotalAccuracyReactive(dsToken, data, signalController)

    if (this.props.error) {
      renderToastWarn(this.props.error)
    } else {
      const content = {
        data: this.buildRows(),
        total: this.props.count,
        year: data.dtYear
      }
      if(this.props.canceled) {
        hideSpinner()
      }
      if(!this.props.canceled) {
        this.setState({ formData: data })
        callback(content)
      }

    }
  }

  onSubmit = async (data, callback) => {
    const {
      auth: {
        user: { dsToken },
      },
      hideSpinner,
      fetchTotalAccuracy
    } = this.props

    delete data.period
    data.size = 10
    data.hasPagination = true

    signalController = new AbortController();
    await fetchTotalAccuracy(dsToken, data, signalController)

    if (this.props.error) {
      renderToastWarn(this.props.error)
    } else {
      const content = {
        data: this.buildRows(),
        total: this.props.count,
        year: data.dtYear
      }
      if(this.props.canceled) {
        hideSpinner()
      }
      if(!this.props.canceled) {
        this.setState({ formData: data })
        callback(content)
      }

    }
  }

  onExport = async (callback) => {
    const {
      auth: {
        user: { dsToken },
      },

      fetchFluxReport,
      translate
    } = this.props

    const { formData } = this.state

    signalController = new AbortController();
    await fetchFluxReport(dsToken, {tpReport: 37}, formData, translate,  signalController)
    // await fetchReports(dsToken, { tpReport: 10 }, formData)

    const callbackReturn = true
    callback(callbackReturn)
  }

  render() {
    const { translate, record } = this.props
    return (
      <CommonReport
        showDate
        fluxPOC
        onSubmitFlux={this.onSubmitFlux}
        controlledSpinner
        translate={translate}
        title={translate('totalAccuracy.title')}
        onSubmit={this.onSubmit}
        fields={this.getFormFields()}
        columns={this.getColumns()}
        onExport={this.onExport}
        emptyReportMsg='totalAccuracy.return.filter'
        topLeftPart={() => (
          <>
            {record.cdLm && (
              <span>
                <b style={{whiteSpace: 'nowrap'}}>
                  {record.cdLm} - {record.dsLm}
                </b>
              </span>
            )}
            <br />
            {record.cdSection && (
              <span>
                <b>
                  {translate('section')} {record.cdSection} - {record.dsSection}
                </b>
              </span>
            )}
          </>
        )}
      />
    )
  }
}

const mapStateToProps = ({
  totalAccuracyReducer,
  paginateReducer,
  reportReducer,
}) => ({
  count: paginateReducer.count,
  current: paginateReducer.current,
  error: reportReducer.get.error,
  canceled: totalAccuracyReducer.canceled,
  pages: paginateReducer.pages,
  record: totalAccuracyReducer.record,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...totalAccuracyActions, ...reportActions, ...spinnerActions }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  translate(null, { wait: true, translateFuncName: 'translate' })(TotalAccuracy)
)
export { TotalAccuracy }
